import { render } from "./AcceptedPictorialsView.vue?vue&type=template&id=1c4b425a&scoped=true"
const script = {}

import "./AcceptedPictorialsView.vue?vue&type=style&index=0&id=1c4b425a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4b425a"]])

export default __exports__